import React from 'react';
import { motion } from 'framer-motion';
import { StarRating } from './StarRating';
const services = [{
  title: 'Review Schema Architecture',
  desc: 'We build structured data systems that make your star ratings, pros/cons, and scores visible in search results. Rich snippets that drive clicks.',
  rating: 5
}, {
  title: 'Monetization Rewiring',
  desc: 'Affiliate link optimization, ad placement strategy, sponsored content frameworks. We turn traffic into EUR.',
  rating: 4.5
}, {
  title: 'Topical Authority Mapping',
  desc: 'Content architecture that builds domain authority across gaming niches. From RPGs to racing sims, we map the territory.',
  rating: 5
}, {
  title: 'Comparison Engine SEO',
  desc: 'Technical optimization for comparison tables, filters, and dynamic content. Making the unindexable indexable.',
  rating: 4
}, {
  title: 'Editorial Content Strategy',
  desc: 'Review templates, scoring rubrics, and content calendars that align with search intent and user trust.',
  rating: 5
}, {
  title: 'Performance Analytics',
  desc: 'Custom dashboards tracking revenue per review, ranking velocity, and conversion paths.',
  rating: 4.5
}];
export function Services() {
  return <section id="services" className="py-32 bg-gameu-base relative" data-id="element-134">
      <div className="max-w-7xl mx-auto px-6" data-id="element-135">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16" data-id="element-136">
          <h2 className="font-serif text-5xl md:text-6xl text-gameu-text mb-6" data-id="element-137">
            What We Engineer
          </h2>
          <p className="text-gameu-muted text-lg max-w-2xl" data-id="element-138">
            Precision SEO and monetization strategies designed exclusively for
            the architecture of review and comparison platforms.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-139">
          {services.map((service, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-gameu-elevated p-8 border border-transparent hover:border-gameu-accent/50 transition-colors flex flex-col h-full" data-id="element-140">
              <div className="mb-6" data-id="element-141">
                <StarRating rating={service.rating} starSize={16} data-id="element-142" />
              </div>
              <h3 className="text-xl font-medium text-gameu-text mb-4" data-id="element-143">
                {service.title}
              </h3>
              <p className="text-gameu-muted text-sm leading-relaxed flex-grow" data-id="element-144">
                {service.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}